import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import AddressFormLoading from '@/_containers/inputs/address/loading';

export default function Loading({ isModal = false }: { isModal?: boolean }) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} withBreadcrumb isModal={isModal} />

      <Container>
        <LeftSection forceFullWidth={isModal}>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
            </FormLayout>
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton />

            <AddressFormLoading />
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton />

            <AddressFormLoading />
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
